export enum ApprovalAction {
  Approve = 'APPROVE',
  ForceApprove = 'FORCE_APPROVE',
  Skip = 'SKIP',
  Reject = 'REJECT',
  ReassignApprovers = 'REASSIGN_APPROVERS',
}

export enum EngagementAction {
  ReassignEngagement = 'REASSIGN_ENGAGEMENT',
  Skip = 'SKIP',
  RerunAccountingSync = 'RERUN_ACCOUNTING_SYNC',
}

export enum RfxAction {
  Skip = 'SKIP',
  ReassignOwners = 'REASSIGN_OWNERS',
  AwardSupplier = 'AWARD_SUPPLIER',
  MultiAwardSuppliers = 'MULTI_AWARD_SUPPLIERS',
}

export enum AuctionAction {
  ReassignOwners = 'REASSIGN_AUCTION_OWNERS',
  AwardSupplier = 'AWARD_AUCTION_SUPPLIER',
  MultiAwardSuppliers = 'MULTI_AWARD_AUCTION_SUPPLIERS',
}

export enum CreateAgreementAction {
  Skip = 'SKIP',
  ReassignApprovers = 'REASSIGN_CREATE_AGREEMENT',
}

export enum CancelAgreementAction {
  Skip = 'SKIP',
  ReassignApprovers = 'REASSIGN_CANCEL_AGREEMENT',
}

export enum CommitSupplierDataAction {
  Skip = 'SKIP',
  ReassignAssignees = 'REASSIGN_ASSIGNEES',
  RerunAccountingSync = 'RERUN_ACCOUNTING_SYNC',
}

export enum CreatePOAction {
  Skip = 'SKIP',
  ReassignAssignees = 'REASSIGN_PO_ASSIGNEES',
  RerunAccountingSync = 'RERUN_ACCOUNTING_SYNC',
}

export enum RenewalAssessmentAction {
  ReassignRenewalAssessment = 'REASSIGN_RENEWAL_ASSESSMENT',
}

export enum SupplierPortalAction {
  Skip = 'SKIP',
  ReassignSuppliers = 'REASSIGN_SUPPLIERS',
}

export enum CreateRenewalAction {
  Skip = 'SKIP',
  ReassignApprovers = 'REASSIGN_CREATE_RENEWAL',
}

export enum ExternalOperationExecutionAction {
  EXTERNAL_EXECUTION_COMPLETE = 'EXTERNAL_EXECUTION_COMPLETE',
  EXTERNAL_EXECUTION_UPDATE = 'EXTERNAL_EXECUTION_UPDATE',
  ERROR = 'ERROR',
  ReassignAssignees = 'REASSIGN_EXTERNAL_OPERATION',
}

export enum ExternalProcedureAction {
  PROCEDURE_RUN_COMPLETE = 'PROCEDURE_RUN_COMPLETE',
  PROCEDURE_RUN_FAILED = 'PROCEDURE_RUN_FAILED',
  ReassignAssignees = 'REASSIGN_EXTERNAL_PROCEDURE',
}

export enum CreateAssessmentAction {
  Skip = 'SKIP',
  ReassignApprovers = 'REASSIGN_CREATE_ASSESSMENT',
}

export enum SupplierOnlineResourcesAction {
  ReassignAssignees = 'REASSIGN_SUPPLIER_ONLINE_RESOURCES',
}

export enum PriceBenchmarkAction {
  AgentResult = 'PRICE_BENCHMARK_AGENT_RESULT',
  ReassignAssignees = 'REASSIGN_PRICE_BENCHMARK',
  Skip = 'SKIP',
}

export enum AiFormCompletionAction {
  AgentResult = 'AI_FORM_COMPLETION_AGENT_RESULT',
  ReassignAssignees = 'REASSIGN_AI_FORM_COMPLETION',
}

export enum InherentRiskAssessmentAction {
  AgentResult = 'INHERENT_RISK_ASSESSMENT_AGENT_RESULT',
}

export enum CancelAssessmentsAction {
  ReassignAssignees = 'REASSIGN_CANCEL_ASSESSMENTS',
}

export enum RequestStepAction {
  REASSIGN_APPROVERS = 'REASSIGN_APPROVERS',
  REASSIGN_SUPPLIER = 'REASSIGN_SUPPLIER',
  REASSIGN_ENGAGEMENT = 'REASSIGN_ENGAGEMENT',
  REASSIGN_TO_SELF = 'REASSIGN_TO_SELF',
  FORCE_APPROVE = 'FORCE_APPROVE',
  SKIP = 'SKIP',
  REASSIGN_RENEWAL_ASSESSMENT = 'REASSIGN_RENEWAL_ASSESSMENT',
  REASSIGN_EXTERNAL_OPERATION = 'REASSIGN_EXTERNAL_OPERATION',
  REASSIGN_EXTERNAL_PROCEDURE = 'REASSIGN_EXTERNAL_PROCEDURE',
  ROLLBACK = 'ROLLBACK',
  HTTP_RETRY = 'HTTP_RETRY',
  RERUN_ACCOUNTING_SYNC = 'RERUN_ACCOUNTING_SYNC',
  REASSIGN_PO_ASSIGNEES = 'REASSIGN_PO_ASSIGNEES',
  UN_SKIP = 'UN_SKIP',
  POLL = 'POLL',
  REFRESH_STATUS = 'REFRESH_STATUS',
  UPDATE_CONFIG = 'UPDATE_CONFIG',
  DATA_TRANSFORMATION_RETRY = 'DATA_TRANSFORMATION_RETRY',
  SKIP_CONDITIONS = 'SKIP_CONDITIONS',
  PROCEDURE_RETRY = 'PROCEDURE_RETRY',
}
